import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';


@Directive({
  selector: '[appTicketRocket]'
})
export class TicketRocketDirective {

  constructor(private el: ElementRef, public router: Router) { 
   
  }

  @HostListener('click') click() {
    this.flyAway();
  }

  private flyAway() {
    
    this.el.nativeElement.className += 'ticketClicked';
    this.sleep(3000).then(() => { this.router.navigate(['/tickets']); });
  }

  // solution quoted from here: https://www.sitepoint.com/delay-sleep-pause-wait/
  private sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  // end of quote

}
